export function replaceStringVariables(str, varsConfig) {
  let replacedStr = str;

  for (const key in varsConfig) {
    if (varsConfig.hasOwnProperty(key)) {
      const placeholder = `{{${key}}}`;
      const value = varsConfig[key];
      replacedStr = replacedStr.replace(placeholder, value);
    }
  }

  return replacedStr;
}
